/**
 * HOROSCOPE ENDPOINT
 * ==================
 * There is a SINGLE backend endpoint that returns everything the horoscope
 * page needs, as a server-driven list of widgets (see api/types.ts).
 *
 * This file just names that endpoint and types its response. The actual
 * network mechanics (auth, errors, JSON) live in api/client.ts.
 */
import { apiClient } from './client'
import { HoroscopeFeedResponse } from './types'
import { USE_MOCK } from '../config'
import { horoscopeFeedMock } from './horoscope.mock'

/**
 * The user is identified by the V2 identity headers (X-SHARECHAT-USERID +
 * auth token; the gateway validates them), so no userId is needed in the URL.
 */
const HOROSCOPE_FEED_PATH = '/mashvara-service/v1/public/astrology/horoscope/today'

/** Fetch the full horoscope page (the ordered list of widgets to render). */
export function getHoroscopeFeed(signal?: AbortSignal): Promise<HoroscopeFeedResponse> {
  if (USE_MOCK) return Promise.resolve(horoscopeFeedMock)
  return apiClient.get<HoroscopeFeedResponse>(HOROSCOPE_FEED_PATH, signal)
}
